import React from 'react';
import { formatKpiAdaptiveINR } from '../../../utils/kpiAmountFormat';
import { formatCountValue } from './reportUtils';

const Kpi = ({ label, value }) => (
  <div className="sm-kpi-card sm-kpi-card--compact">
    <p className="sm-kpi-card__label">{label}</p>
    <p className="sm-kpi-card__value">{value}</p>
  </div>
);

/**
 * Executive KPIs by group (informational only). Correspondence includes period inward/outward.
 */
const ExecutiveSummaryCards = ({ summary }) => {
  const s = summary || {};
  const agr = s.agreementValueDisplay;
  const agrNum = agr != null && agr !== '' ? Number(agr) : NaN;
  const agrLabel = s.agreementValueIsSingleProject ? 'Project agreement value' : 'Total projects agreement value';
  const agrFmt = Number.isFinite(agrNum) ? formatKpiAdaptiveINR(agrNum) : '—';
  const groups = [
    {
      label: 'Correspondence',
      items: [
        ['Entries (period)', formatCountValue(s.totalCorrespondenceEntries)],
        ['Inward (period)', formatCountValue(s.correspondenceInward)],
        ['Outward (period)', formatCountValue(s.correspondenceOutward)],
        ['Open Subjects', formatCountValue(s.totalOpenChains)],
        ['Targeted reply overdue', formatCountValue(s.totalOverdueTargetedReplies)],
      ],
    },
    {
      label: 'RA bills',
      items: [
        [agrLabel, agrFmt],
        ['Cumulative gross (latest RA per stream)', formatKpiAdaptiveINR(s.totalRABillGrossValue)],
        ['Net value (CPWD)', formatKpiAdaptiveINR(s.totalRABillNetValue)],
        ['Received value', formatKpiAdaptiveINR(s.totalRABillReceivedValue)],
        ['Pending value', formatKpiAdaptiveINR(s.totalRABillPendingValue)],
      ],
    },
    {
      label: 'BG / insurance',
      items: [
        ['BG count', formatCountValue(s.totalBGCount)],
        ['BG value', formatKpiAdaptiveINR(s.totalBGValue)],
        ['Insurance count', formatCountValue(s.totalInsuranceCount)],
      ],
    },
    {
      label: 'Technical / controls',
      items: [
        ['Drawings', formatCountValue(s.totalDrawings)],
        ['Deviations', formatCountValue(s.totalDeviations)],
        ['QAQC items', formatCountValue(s.totalQAQCItems)],
      ],
    },
  ];

  return (
    <section id="sm-exec" className="sm-exec">
      <h2 className="sm-exec__title">Executive summary</h2>
      <p className="sm-exec__lead">
        Portfolio-level metrics. Correspondence uses the selected date range; RA gross matches the register (latest bill per project stream). Net / received / pending sum all RA bills in scope.
      </p>
      <div className="sm-exec__groups">
        {groups.map((g) => (
          <div key={g.label} className="sm-exec__group">
            <div className="sm-exec__group-label">{g.label}</div>
            <div className="sm-exec__grid">
              {g.items.map(([label, value]) => (
                <Kpi key={label} label={label} value={value != null && value !== '' ? String(value) : '—'} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExecutiveSummaryCards;
